<template>
  <tr>
    <td>{{ keyPair }}</td>
    <td>{{ valuePair }}</td>
    <td v-if="isDownloadableReport">
      <button :disabled="isDownloading" class="uk-button uk-button-small" @click="onDownloadClick">Download</button>
      <div v-if="isDownloading" uk-spinner></div>
    </td>
  </tr>
</template>

<script>
  import Toast from '@/helpers/Toast';
  import { getToken } from '@/common/auth';

  /**
   * Reprents a single Table Row of an Import Report.
   * Handles downloading the import file.
   */
  export default {
    name: 'import-report-detail',
    props: {
      keyPair: String,
      valuePair: String,
    },
    data() {
      return {
        isDownloading: false,
      };
    },
    computed: {
      isDownloadableReport() {
        return this.valuePair && this.valuePair.startsWith('static/');
      },
    },
    methods: {
      reportDownloadLink() {
        if (!this.valuePair) {
          return '';
        }
        const reportPath = this.valuePair.replaceAll('static/', '');
        return `/downloads/reports/${reportPath}`;
      },
      async onDownloadClick() {
        this.isDownloading = true;
        const authToken = await getToken();
        const response = await fetch(this.reportDownloadLink(), {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status !== 200) {
          this.isDownloading = false;
          if (response.status === 404) {
            Toast.error(this.$t('toasts.fileNotFound'));
            return;
          }
          Toast.error('Download failed, see console for details');
          // eslint-disable-next-line
          console.error(response);
          return;
        }
        // Parse the Content-Disposition header to retrieve the file name
        // Otherwise the file gets a random name which is not desirable
        // Example of the Content-Disposition Header:
        // attachment; filename="example"
        const responseHeader = response.headers.get('Content-Disposition');
        const parts = responseHeader.split(';');
        const fileName = parts[1].split('=')[1].replaceAll('"', '');
        const blob = await response.blob();
        if (blob === null) {
          Toast.error('Response from download is empty for details');
          // eslint-disable-next-line
          console.error(response);
          this.isDownloading = false;
          return;
        }
        // Download the file
        const url = window.URL.createObjectURL(blob);
        const temporaryAnchor = document.createElement('a');
        temporaryAnchor.href = url;
        temporaryAnchor.download = fileName;
        document.body.appendChild(temporaryAnchor);
        temporaryAnchor.click();
        temporaryAnchor.remove();
        this.isDownloading = false;
      },
    },
    i18n: {
      messages: {
        de: {
          toasts: {
            // eslint-disable-next-line
            fileNotFound: 'Der Report existiert auf dem Server nicht mehr, da sie nach 2 Wochen gelöscht wird.',
          },
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// ImportReportDetail.vue?c70bcdde